<template>
  <div class="ticketIncidentCon">
    <div>
      <ul>
        <li v-for="(item, index) in incidents" :key="index">
          <dl>
            <dt>{{ item.data.agentName }} <span>{{ convert(item.data.createDate) }}</span></dt>
            <dd class="txt" v-html="item.data.content || '-'"></dd>
            <dd class="btns">
              <v-btn v-if="checkChatModule(item.ticketEvent.code)" outline class="UXbtn small" @click="chatRoomView(item.data)" :disabled="!isPermission['read']">
                レビュー
              </v-btn>
              <v-btn v-if="checkCallModule(item.ticketEvent.code)" outline class="UXbtn small" @click="playCallRecord(item.data)" :disabled="!isPermission['listen']">
                聞く
              </v-btn>
              <v-btn v-if="checkMessageModule(item.ticketEvent.code)" outline class="UXbtn small" @click="messageDetailView(item.data)">
                送信結果
              </v-btn>
              <v-btn v-if="isMailModule(item.ticketEvent.code)" outline class="UXbtn small" @click="showMailView(item.data)" :disabled="!isPermission['read']">
                レビュー
              </v-btn>
              <v-btn v-if="isSurveySubmit(item.ticketEvent.code)" outline class="UXbtn small" @click="showSurveyView(item.data)" :disabled="!isPermission['read']">
                レビュー
              </v-btn>
            </dd>
            <dd class="img"><img :src="getChannelIcon(item.data.channelName)" :class="{ 'mt-1': true, 'fb': item.data.channelName === 'FACEBOOK_TALK'}"></dd>
          </dl>
        </li>
      </ul>
    </div>
    <div class="UXnotData" style="height:490px" v-if="incidents.length === 0">
      ヒストリーがありません。
    </div>
    <message-detail></message-detail>
  </div>
</template>

<script>
import Helpers from '@/util/helpers'
import TicketListUtil from '../util/ticket_list_util'
import eventBus from '@/event_bus'
import eventType from '@/components/menus/ticket/enums/eventType'
import helper from 'util/helpers'
import messageDetail from '@/components/menus/ticket/component/message_details_dialog'
import {mapGetters, mapMutations} from 'vuex'

export default {
  name: 'ticket_incident_list',
  components: {messageDetail},
  props: ['isPermission'],
  data () {
    return {
      displayId: '',
      incidents: [],
      avatar: '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/avatars/brand-profile-img.png',
      dialog: false,
      messageHistoryId: null,
      messageDialog: false
    }
  },
  computed: {
    ...mapGetters([
      'loginId',
      'incidentList',
      'agentMappingBrandViews',
      'currentBrandId',
      'callMode'
    ])
  },
  destroyed () {
    eventBus.$off(eventType.FETCH_INCIDENT_LIST)
  },
  mounted () {
    if (!this.$route.query.displayId) {
      return
    }
    this.displayId = this.$route.query.displayId.replace('#', '')
    this.fetchIncidentList()

    eventBus.$on(eventType.FETCH_INCIDENT_LIST, () => {
      this.fetchIncidentList()
    })
  },
  methods: {
    ...mapMutations([
      'setIncidentList'
    ]),
    playCallRecord (data) {
      if (this.callMode === 'NEOMECCA') {
        if (!data.data.callRecFileName) {
          this.$alertMsg('録音ファイルが存在しないか、正しいファイルではありません。')
          return
        }
        this.findTicketCallBrand(data.data.callRecId)
      } else {
        if (!data.data.callSummaryId) {
          this.$alertMsg('録音ファイルが存在しないか、正しいファイルではありません。')
          return
        }
        this.getCallRecordUri(data.data.callSummaryId)
      }
    },
    getCallRecordUri (callSummaryId) {
      this.$http.get(`/api/call/summary/${callSummaryId}/record/uri`).then(result => {
        if (result.data.code === 0) {
          let recordUrl = result.data.data
          window.open(recordUrl, '_blank')
        } else {
          this.$alertMsg(result.data.message)
        }
      }).catch(err => {
        this.$alertMsg(err)
      })
    },
    fetchRecord (callRepresentativeNumber, recId) {
      this.axios.get('/api/apps/call/record', {
        params: {
          callRepresentativeNumber: callRepresentativeNumber,
          recordKey: recId
        }
      }).then(result => {
        if (result.data.code === 0) {
          if (result.data.data && result.data.data.privateKey === recId) {
            if (helper.isStringValid(result.data.data.adminId)) {
              window.open(Helpers.findCallUrl(result.data.data.callServerType) + '/CtiManager/neoplay/NeoPlay.do?loginId=' + result.data.data.adminId + '&privateKey=' + result.data.data.privateKey + '&&rec_bak=' + result.data.data.recBack, '_blank', 'toolbar=no,menubar=no,resizable=1,width=730, height=600')
            } else {
              this.$alertMsg('録音聴取が可能なブランドではありません。')
            }
          }
        }
      })
    },
    findTicketCallBrand (recId) {
      const brandId = this.currentBrandId || this.agentMappingBrandViews.sort((s1, s2) => s1.brandId - s2.brandId)[0].brandId
      this.axios.get('/gateway/ticket/ticketBrandByTalkBrandId', {
        params: {
          talkBrandId: brandId
        }
      }).then(result => {
        if (result.data.code !== 0) {
          this.$alertMsg('録音聴取が可能なブランドではありません。')
        } else {
          const data = result.data.data
          if (data.callBrandId) {
            this.fetchRecord(data.callBrandId, recId)
          } else {
            this.$alertMsg('録音聴取が可能なブランドではありません。')
          }
        }
      })
    },
    chatRoomView (data) {
      let left = screen.width + window.screenX
      let top = screen.height + window.screenY
      const chatRoomId = data.data.chatRoomId
      if (chatRoomId) {
        window.open(location.protocol.concat('//', window.location.hostname + ':' + window.location.port, `/external/chat_messages?chatRoomId=${chatRoomId}`), chatRoomId, 'toolbar=no,menubar=no,resizable=1,width=410, height=728, top=' + top + ', left=' + left + '')
      } else {
        this.$alertMsg('正しいチャットルーム情報ではありません。')
      }
    },
    messageDetailView (data) {
      this.messageHistoryId = data.data.messageHistoryId
      eventBus.$emit(eventType.OPEN_MESSAGE_DETAIL_DIALOG, data.data.messageHistoryId)
    },
    showMailView (data) {
      let left = screen.width + window.screenX
      let top = screen.height + window.screenY
      const chatRoomId = data.data.chatRoomId
      if (chatRoomId) {
        window.open(location.protocol.concat('//', window.location.hostname + ':' + window.location.port, `/external/chat_messages?chatRoomId=${chatRoomId}`), chatRoomId, 'toolbar=no,menubar=no,resizable=1,width=820, height=728, top=' + top + ', left=' + left + '')
      } else {
        this.$alertMsg('情報が確認されません。')
      }
    },
    showSurveyView (data) {
      console.log(JSON.stringify(data))
      let left = screen.width + window.screenX
      let top = screen.height + window.screenY
      const surveyDetailsUuid = data.data.surveyDetailsUuid
      if (surveyDetailsUuid) {
        window.open(location.protocol.concat('//', window.location.hostname + ':' + window.location.port, `/survey/result?uuid=${surveyDetailsUuid}`), surveyDetailsUuid, 'toolbar=no,menubar=no,resizable=1,width=410, height=728, top=' + top + ', left=' + left + '')
      } else {
        this.$alertMsg('情報が確認されません。')
      }
    },
    checkChatModule (code) {
      const chatCode = [3109, 3209, 3309, 3108, 3208, 3308, 3002, 4103, 3408, 3409, 3508, 3509]
      return chatCode.indexOf(code) > -1
    },
    checkCallModule (code) {
      return code === 2309
    },
    checkMessageModule (code) {
      return code === 5101 || code === 5104
    },
    isMailModule (code) {
      return code === 6006
    },
    isSurveySubmit (code) {
      return code === 1211
    },
    convert (dateTime) {
      return dateTime !== undefined ? Helpers.convertCreateDateToYYYYMMDDhhmmss(dateTime) : '-'
    },
    getChannelIcon (name) {
      return TicketListUtil.getChannelIcon(name)
    },
    fetchIncidentList () {
      this.axios.get('/gateway/ticket/details', {
        params: {
          displayId: this.displayId.replace('#', '')
        }
      })
        .then(result => {
          if (result.data.code === 0) {
            this.incident = result.data.data.ticketIncidents
            this.incidents = result.data.data.ticketIncidents.map(incident => {
              if (incident.hasOwnProperty('data')) {
                return {
                  ticketEvent: incident.ticketEvent,
                  data: JSON.parse(incident.data)
                }
              } else {
                return {content: 'data 無し'}
              }
            })
            this.setIncidentList(this.incidents)
          } else {
            this.$alertMsg(result.data.message)
          }
        })
    }
  }
}
</script>

<style lang="scss">
  .ticketIncidentCon {
    margin-bottom:30px;
    overflow-y:auto;
    border-bottom: 1px solid $gray-3;
    max-height: 500px;
    ul {
      padding:0;
      li {
        padding:0 20px;
        min-height:55px;
        list-style: none;
        border-bottom: 1px solid $gray-3;
        &:last-child {
          border-bottom: 0;
        }
        dl {
          position: relative;
          padding:10px 70px 10px 50px;
          dt {
            font-weight: bold;
            font-size: 12px;
            color:$gray-8;
            span {
              font-weight: 500;
              color:$gray-6;
            }
          }
          dd {
            &.img {
              position: absolute;
              top:5px;
              left:0;
              img {
                width:35px;
                &:not(.fb) {
                  border-radius: 50%;
                }
              }
            }
            &.txt {
              font-size: 14px;
              line-height: normal;
              color:$gray-8;
              > p {
                margin-bottom: 0;
              }
            }
            &.btns {
              position: absolute;
              top:50%;
              right:0;
              margin-top: -13px;
              .v-btn {
                padding: 0 8px;
                min-width: 65px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/fragments/ticket_incident_list.vue